import React from "react";
import moment from "moment";

function AnalyticsHeader({ exam, overall, onBack, onClose, parseExamStart, formatSectionsDisplay }) {
    const start = parseExamStart(exam.start_time);
    return (
        <div
            className="d-flex justify-content-between align-items-start flex-wrap"
            style={{ gap: 14, padding: "14px 20px", borderBottom: "1px solid #e5e7eb", background: "#fff" }}
        >
            <div className="d-flex align-items-start" style={{ gap: 12 }}>
                <button
                    type="button"
                    onClick={onBack}
                    className="btn btn-sm btn-outline-secondary"
                    style={{ borderRadius: 8, flexShrink: 0 }}
                >
                    <i className="fal fa-arrow-left mr-1" /> Back
                </button>
                <div>
                    <h5 className="font-weight-bold text-dark mb-1">{exam.exam_name}</h5>
                    <div className="d-flex flex-wrap text-muted" style={{ gap: 14, fontSize: 12.5 }}>
                        <span>
                            <i className="fal fa-clock mr-1" />
                            {start.isValid() ? start.format("DD MMM YYYY, hh:mm A") : "-"}
                        </span>
                        <span>
                            <i className="fal fa-users mr-1" />
                            {exam.class_name}
                            {exam.sectionLabels && exam.sectionLabels.length > 0 ? ` (${formatSectionsDisplay(exam.sectionLabels)})` : ""}
                        </span>
                    </div>
                </div>
            </div>

            <div className="d-flex flex-wrap" style={{ gap: 10 }}>
                {[
                    { label: "Total Students", value: overall.totalStudents, color: "#1d4ed8", bg: "#eff6ff" },
                    { label: "Avg Marks", value: overall.averageMarks, color: "#15803d", bg: "#f0fdf4" },
                    { label: "Avg Accuracy", value: `${overall.averageAccuracy}%`, color: "#c2410c", bg: "#fff7ed" },
                ].map((s) => (
                    <div
                        key={s.label}
                        style={{ background: s.bg, borderRadius: 10, padding: "6px 14px", textAlign: "center", minWidth: 96 }}
                    >
                        <div style={{ color: s.color, fontWeight: 700, fontSize: 16 }}>{s.value}</div>
                        <div className="text-muted" style={{ fontSize: 11 }}>{s.label}</div>
                    </div>
                ))}
                <button
                    type="button"
                    onClick={onClose}
                    className="btn btn-sm btn-outline-danger"
                    style={{ borderRadius: 8, alignSelf: "flex-start" }}
                >
                    <i className="fal fa-times mr-1" /> Close
                </button>
            </div>
        </div>
    );
}

export default AnalyticsHeader;
